import React from 'react'
import "./Hero.css"
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import { Container } from 'react-bootstrap';

const Hero = ({ url,data ,language}) => {

  const heroSection = data?.find(item => item.section === "Service Hero Section");
  const hero_gallery = heroSection?.data?.hero_gallery || [];


  return (
    <div className="hero-services">
      <Swiper
        modules={[Pagination]}
        pagination={{ clickable: true }}
        direction="horizontal"
        breakpoints={{
          768: {
            // Screens with width 768px and below
            direction: language === "ar" ? "horizontal" : "vertical", // Ensure vertical direction for Arabic on small screens
          },
        }}
      >
        {hero_gallery.map((item, index) => (
          <SwiperSlide key={index}>
            <img
              src={url + item.image}
              className="hero-image"
              alt={item.alt_text || "Hero Image"}
            />
            <div className="hero-cotnainer">
              <Container>
                <div className="hero-content">
                  <div
                    className="hero-para"
                    dangerouslySetInnerHTML={{
                      __html:
                        language === "ar"
                          ? item.description_ar
                          : item.description,
                    }}
                  />
                </div>
              </Container>
            </div>
          </SwiperSlide>
        ))}

        {/* <SwiperSlide>
          <img
            src={require("../../../../Assets/Images/hero1.png")}
            className="hero-image"
          />
          <div className="hero-cotnainer">
            <Container>
              <div className="hero-content">
                <div className="hero-title">interior design</div>
                <div className="hero-para">
                  ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum
                  nisl leo amet, consectetur adipisci. ipsum dolor sit ametleo
                  amet, consectetur adipisci. ipsum dolor sit amet
                </div>
              </div>
            </Container>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <img
            src={require("../../../../Assets/Images/hero1.png")}
            className="hero-image"
          />
          <div className="hero-cotnainer">
            <Container>
              <div className="hero-content">
                <div className="hero-title">interior design</div>
                <div className="hero-para">
                  ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum
                  nisl leo amet, consectetur adipisci. ipsum dolor sit ametleo
                  amet, consectetur adipisci. ipsum dolor sit amet
                </div>
              </div>
            </Container>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <img
            src={require("../../../../Assets/Images/hero1.png")}
            className="hero-image"
          />
          <div className="hero-cotnainer">
            <Container>
              <div className="hero-content">
                <div className="hero-title">interior design</div>
                <div className="hero-para">
                  ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum
                  nisl leo amet, consectetur adipisci. ipsum dolor sit ametleo
                  amet, consectetur adipisci. ipsum dolor sit amet
                </div>
              </div>
            </Container>
          </div>
        </SwiperSlide> */}
      </Swiper>
    </div>
  );
}

export default Hero